import cleanedFilename from '~/util/cleanedFilename';

export default {
  SUBSCRIPTION_INFO: `${cleanedFilename(__filename)}-subscription-info`,
  SUBSCRIPTION_TITLE: `${cleanedFilename(__filename)}-subscription-title`,
};
